import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;    
    height: 53.5px;
    width: 100%; 
    margin-top: 23px;   
`